/**
 * Anmeldung mit BENUTZERNAME statt E-Mail.
 *
 * Supabase meldet technisch immer per E-Mail an. Damit trotzdem niemand seine E-Mail-Adresse tippen
 * muss, bilden wir die Eingabe hier im Frontend ab:
 *   - ein reiner Benutzername (ohne "@")  ->  <benutzername>@<firmendomain>
 *   - eine vollständige E-Mail (mit "@")   ->  unverändert übernommen (bleibt rückwärtskompatibel,
 *                                              damit bestehende Konten nie ausgesperrt werden)
 * Alles wird klein geschrieben, damit Groß-/Kleinschreibung nie zur Fehlerquelle wird.
 *
 * Die Firmendomain lässt sich per VITE_LOGIN_DOMAIN setzen; Standard ist die FTW-Domain, weil die
 * Benutzerkonten dort als <benutzername>@foerdertechnik-werl.de liegen.
 */

export const LOGIN_DEFAULT_DOMAIN = 'foerdertechnik-werl.de';

export function resolveLoginEmail(input: string, domain: string = LOGIN_DEFAULT_DOMAIN): string {
  const value = input.trim().toLowerCase();
  if (!value || value.includes('@')) return value;
  return `${value}@${domain}`;
}

/** Die konfigurierte Firmendomain (Env vor Standard) -- an einer Stelle, damit UI und Auflösung übereinstimmen. */
export function loginDomain(env?: { readonly VITE_LOGIN_DOMAIN?: string }): string {
  const configured = env?.VITE_LOGIN_DOMAIN?.trim();
  return configured && configured.length > 0 ? configured.toLowerCase() : LOGIN_DEFAULT_DOMAIN;
}
